<p-dialog [header]="patientHeader" [modal]="true" [(visible)]="loadDialogView" [style]="{ width: '60rem' }"
    (onHide)="closeDialog(false)">
    @for (tab of patientAttributeData?.tabs; track tab; let i = $index) {
    <div>
        <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues" [moduleName]="moduleName"
            [groups]="tab.groups" (saveData)="onSavePatient($event)" [activeIndex]="0"
            [isMultipleFilesUpload]="false" [submitBtnText]="patienSubmitBtn" [showCancelButton]="true"
            [saveBtnId]="prefixToAttachForButtonIdToUniquelyIdentifyButton + tab.tabCode"
            (onCancel)="closeDialog(false)"></app-mi-form>
    </div>

    }

</p-dialog>